const Menu = [
  {
    label: 'Info',
    pathname: '/admin',
  },
  {
    label: 'Project',
    pathname: '/admin/project',
  },
  {
    label: 'Clients',
    pathname: '/admin/client',
  },
  {
    label: 'Admin',
    pathname: '/admin/users',
  },
];

export default Menu;
